/* eslint-disable no-undef */
import { LitElement } from 'lit';
import { MessageBus } from '@podium/browser';

class TopbarDataService extends LitElement {
    #unauthorised = false;

    static get properties() {
        return {
            loginId: { type: String, attribute: 'login-id' },
            spidId: { type: String, attribute: 'spid-id' },
            apiUrl: { type: String, attribute: 'api-url' },
        };
    }

    get topbarEl() {
        return document.querySelector('finn-topbar');
    }

    async fetch() {
        // @ts-ignore
        if (!this.loginId || !this.spidId || this.#unauthorised) return;
        // @ts-ignore
        const res = await fetch(new URL(this.apiUrl), {
            credentials: 'include',
        });

        if (res.ok) {
            const result = await res.json();
            const {
                hasNotifications,
                messagesUnreadCount,
                profileImage,
                profileName,
                profileEmail,
            } = result;

            // @ts-ignore
            this.topbarEl.hasNotifications = Number(hasNotifications) > 0;
            // @ts-ignore
            this.topbarEl.messagesUnreadCount = messagesUnreadCount;
            // @ts-ignore
            this.topbarEl.profileImageURL = profileImage;
            // @ts-ignore
            this.topbarEl.profileName = profileName;
            // @ts-ignore
            this.topbarEl.profileEmail = profileEmail;
        } else if (res.status === 401) {
            this.#unauthorised = true;
        }
    }

    connectedCallback() {
        super.connectedCallback();

        this.fetch();
        setInterval(this.fetch.bind(this), 1000 * 30);

        /**
         * Render broadcast warnings for unsupported browsers
         */
        window.addEventListener('load', async () => {
            try {
                const messageBus = new MessageBus();
                messageBus.subscribe('notifications', 'allWereViewed', () => {
                    if (typeof window !== 'undefined') {
                        // @ts-ignore
                        this.topbarEl.hasNotifications = false;
                    }
                });
            } catch (e) {
                // noop
            }
        });
    }
}

customElements.define('topbar-data-service', TopbarDataService);
